/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 1:43 PM
 *
 */

import MemberTable from 'features/members/components/table/MemberTable/MemberTable';

export default MemberTable;
